import type React from 'react';
import { useEffect } from 'react';
import { TextButton, Toast, useToast } from '@zillow/constellation-10';

import type { LeaseActionProps } from '../../../models/Types';
import { downloadFileFromUrl } from '../../../utils/urlUtils';
import { logError } from '@zg-rentals/log-error';
import { DOWNLOAD_TOAST_MESSAGES, ZILLOW_LEASES_HELP } from '../../../constants/stringConstants';

export default function DownloadLeasePdf({ lease, terminateActiveAction }: LeaseActionProps): React.ReactNode {
  const { enqueueToast } = useToast();

  const onFileDownloadedSuccessToast = () => {
    enqueueToast(<Toast tone="success">{DOWNLOAD_TOAST_MESSAGES.LEASE_SUCCESS}</Toast>);
  };

  const onFileDownloadedErrorToast = () => {
    enqueueToast(
      <Toast
        tone="critical"
        actionButton={
          <TextButton onImpact onClick={() => window.open(ZILLOW_LEASES_HELP, '_blank')}>
            Get lease help
          </TextButton>
        }
      >
        {DOWNLOAD_TOAST_MESSAGES.LEASE_ERROR}
      </Toast>,
    );
  };

  useEffect(() => {
    // eslint-disable-next-line promise/catch-or-return
    downloadFileFromUrl(lease.getPDFLink())
      // eslint-disable-next-line promise/always-return
      .then(() => {
        onFileDownloadedSuccessToast();
      })
      .catch((err) => {
        logError({ error: err, context: 'DownloadLeasePdf - download failed' });
        onFileDownloadedErrorToast();
      })
      .finally(() => {
        terminateActiveAction();
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
